<template>
    <table>
        <tr>
            <th v-for="data in list.normalize" :key="data.key" :class="data.class">
                {{ data.head }}
            </th>
            <th class="is-right">&nbsp;</th>
        </tr>
        <tr v-for="(listData, index) in list.data" :key="`list${index}`">
            <td v-for="data in list.normalize" :key="`list${index}${data.key}`" :class="data.class">
                {{ listData[data.key] }}
            </td>
            <td class="is-right">
                <router-link class="button--primary" :to="{ name: list.update.link.name, params: { id: String(listData[list.update.link.params]) }}" type="button" tag="button">編集</router-link>
            </td>
        </tr>
    </table>
</template>

<script>
    "use strict";

    export default {
        "props": {
            "list": {
                "required": true,
                "type": Object,
            },
        },
    };
</script>
